unit MainDataModule;
interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Modules,
  WEBLib.Forms,
  XData.Web.Connection,
  XData.Web.Client,
  XData.Web.Response,
  WEBLib.Sentry,
  App.Types,
  App.Config,
  Sphinx.WebLogin,
  Data.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.ExtCtrls,
  Sphinx.LoginCommon,
  SMX.Auth.Shared,
  WEBLib.Storage,
  GA.Return.Types,
  WEBLib.DB,
  WEBLib.CDS;

type
  TSphinxWebLoginCracker = class(TSphinxWebLogin)
  public
    [Async]
    procedure LogoutAndEndSessionTo(const APostLogoutRedirectUri: string); async;
  end;

  TMainData = class(TDataModule)
    WebClient: TXDataWebClient;
    DataConnection: TXDataWebConnection;
    SphinxLogin: TSphinxWebLogin;
    MainTimer: TTimer;
    DummyDataset: TClientDataSet;
    DummySource: TDataSource;
    procedure WebDataModuleDestroy(Sender: TObject);
    procedure DataConnectionRequest(Args: TXDataWebConnectionRequest);
    procedure DataConnectionResponse(Args: TXDataWebConnectionResponse);
    procedure MainTimerTimer(Sender: TObject);
    procedure SphinxLoginUserLoggedIn(Args: TUserLoggedInArgs);
    // KSS    procedure WebClientError(Error: TXDataClientError);
    procedure WebDataModuleCreate(Sender: TObject);
  private
    { Private declarations }
    FErrorProc: TErrorMessageProc;
    FLastError: TApplicationError;
    FLastErrorTime: TDateTime;
    FErrorCount: Integer;
    FShowMessageProc: TShowMessageProc;
    FAppUser: TGiftAidUser;
    FTenantId: string;
    FOrganisationName: string;
    FAgentName: string;
    FOrganisationConfiguration: TOrganisationConfiguration;
    FUserIsAgent: Boolean;
    FAgentTenantId: string;
    FAgentId: integer;
    FOrganisationId: integer;
    FSessionRecoveryInProgress: Boolean;
    FSessionLogoutTriggered: Boolean;
    FLogoutInProgress: Boolean;

    //FDonorClaimStatusItemIndex: integer;

    procedure CheckConnection;
    [Async]
    procedure InitModule; async;
    [Async]
    procedure LoadConfig; async;
    [Async]
    procedure GetAppUser; async;

    [Async]
    procedure AfterLogInSuccess(Args: TUserLoggedInArgs); async;

    [Async]
    procedure InitUser; async;

    function GetConfig: TAppConfig;
    function GetLocalValue(const Key: string): string;
    procedure SetLocalValue(const Key, Value: string);
    function GetUserScope: TUserScope;
    [Async]
    procedure GetTenantData; async;
    [Async]
    procedure GetOrganisationName; async;
    [Async]
    procedure GetOrganisationConfiguration; async;
    [Async]
    procedure SetOrganisationConfiguration; async;
    procedure SetConfigurationToDefault;
    function GetOrganisationDisplayName: string;
    procedure SetTenantId(const Value: string);

    [Async]
    procedure InitAgentUser; async;
    [Async]
    procedure GetAgentAppUser; async;
    procedure ConfigureSentryEnvironment;

    [Async]
    procedure CheckAndRefreshSession; async;
    [Async]
    procedure RefreshSessionOrLogout(const AForceRefresh: Boolean); async;
    procedure HandleSessionExpired;

  protected
    function SentryAppId: string;
    function SentryDSN: string;
    function SphinxClientId: string;
    function SphinxRedirectUri: string;
    function SphinxScopes: string;
  public
    { Public declarations }
    procedure OnApplicationError(Sender: TObject; AError: TApplicationError; var Handled: Boolean);

    procedure SaveConfigData;

    [Async]
    procedure ShowMainPage; async;
    procedure Logout(const ShowLogin: Boolean = True);

    procedure SentryErrorProc(E: Exception; const AComment: string; var AHandled: Boolean;
      const CallUIHandler: Boolean = True);

    procedure DeleteLocalValue(const Key: string);
    [Async]
    procedure ShowAgentMainPage; async;

    property Config: TAppConfig read GetConfig;
    property ShowMessageProc: TShowMessageProc write FShowMessageProc;
    property ErrorProc: TErrorMessageProc write FErrorProc;
    property UserScope: TUserScope read GetUserScope;
    property AppUser: TGiftAidUser read FAppUser;

    property LocalValue[const Key: string]: string read GetLocalValue write SetLocalValue;

    property TenantId: string read FTenantId write SetTenantId;
    property AgentTenantId: string read FAgentTenantId;
    property AgentId: integer read FAgentId;
    property UserIsAgent: Boolean read FUserIsAgent write FUserIsAgent;
    property OrganisationConfiguration: TOrganisationConfiguration read FOrganisationConfiguration
      write FOrganisationConfiguration;
    property OrganisationDisplayName: string read GetOrganisationDisplayName;
    property OrganisationId: integer read FOrganisationId write FOrganisationId;

    //property DonorClaimStatusItemIndex: integer read FDonorClaimStatusItemIndex;
  protected procedure LoadDFMValues; override; end;

var
  MainData: TMainData;

implementation

{%CLASSGROUP 'Vcl.Controls.TControl'}

uses
  System.DateUtils,
  System.Rtti,
  WEBLib.Rest,
  WEBLib.WebTools,
  XData.Web.Request,
  MainForm,
  SharedDataModule,
  Auth.Service,
  SMX.JWT.Web.helper,
  RegisterForm,
  RegisterPending,
  AgentSelect,
  Essentials.Web.Shared;

{$R *.dfm}

const
  WEB_SENTRY_DSN = 'https://c17aa4b667554ef29e9954a14f27c8f8@o4504537489473536.ingest.sentry.io/4504854736207872';
  CONTENT_ELEMENT = 'content_here';

procedure TSphinxWebLoginCracker.LogoutAndEndSessionTo(const APostLogoutRedirectUri: string);
var
  LIdToken: string;
  LEndSessionUrl: string;
begin
  LIdToken := '';
  if Storage.AuthResult <> nil then
    LIdToken := Storage.AuthResult.IdToken;

  Logout;
  LEndSessionUrl := await(Client.BuildLogoutUrl(LIdToken, APostLogoutRedirectUri));
  if LEndSessionUrl <> '' then
    window.location.href := LEndSessionUrl;
end;

procedure TMainData.WebDataModuleDestroy(Sender: TObject);
begin
  if Assigned(FAppUser) then
    FAppUser.Free;
end;

const
  TOKEN_REFRESH_BUFFER_SECONDS = 120;

procedure TMainData.AfterLogInSuccess(Args: TUserLoggedInArgs);
var
  lOrgTenant, lOrgKind: string;
  lAgentId: string;
begin
  FSessionLogoutTriggered := False;
  FLogoutInProgress := False;
  MainTimer.Enabled := True;
  AuthService.LogTokenState('AfterLogInSuccess');

  DataConnection.URL := Config.BaseUrl;
  FUserIsAgent := False;

  lOrgKind := AuthService.GetClaimValue(CLAIM_ORGANISATION_KIND);
  lOrgTenant := AuthService.GetClaimValue(CLAIM_ORGANISATION_TENANT_ID);

  if lOrgTenant = ORGANISATION_NOT_CREATED then
  begin
    TRegisterWebForm.DisplayPage(CONTENT_ELEMENT)
  end
  else if lOrgTenant = ORGANISATION_SETUP_PENDING then
  begin
    TPendingWebForm.DisplayPage(CONTENT_ELEMENT);
  end
  else if lOrgKind = 'Agent' then
  begin
    FUserIsAgent := True;
    FAgentName := AuthService.GetClaimValue(CLAIM_AGENT_NAME);
    lAgentId := AuthService.GetClaimValue(CLAIM_AGENT_ID);
    if lAgentId <> '' then
      FAgentId := strtoint(lAgentId);
    FAgentTenantId := lOrgTenant;
    TenantId := lOrgTenant;
    Await(InitUser);
    TAgentSelectionForm.DisplayPage(CONTENT_ELEMENT);
  end
  else
  begin
    TenantId := lOrgTenant;
    if TenantId <> '' then
      Await(InitUser);
    ShowMainPage;
  end;

end;

procedure TMainData.CheckConnection;
begin
  if (DataConnection.URL <> '') and (not DataConnection.Connected) and SphinxLogin.IsLoggedIn then
    DataConnection.Connected := True;
  if (not DataConnection.Connected) then
    raise Exception.Create('Could not connect to server');
end;

// procedure TMainData.DataConnectionError(Error: TXDataWebConnectionError);
// begin
// if Assigned(FShowMessageProc) then
// FShowMessageProc(Error.ErrorMessage, TsmxDlgType.dltError);
// end;

procedure TMainData.DataConnectionRequest(Args: TXDataWebConnectionRequest);
var
  LToken: string;
begin
  if FSessionLogoutTriggered then
    Abort;

  LToken := AuthService.GetAccessToken;
  if LToken = '' then
  begin
{$IFDEF DEBUG}
    AuthService.LogTokenState('DataConnectionRequest: missing token');
{$ENDIF}
    if not (FSessionRecoveryInProgress or FSessionLogoutTriggered) then
      RefreshSessionOrLogout(True);
    Abort;
    Exit;
  end;

  Args.Request.Headers.SetValue('Authorization', 'Bearer ' + LToken);
  if FTenantId <> '' then
    Args.Request.Headers.SetValue(HEADER_TENANT_ID, FTenantId);
  //  else if FAgentTenantId <> '' then
  //    Args.Request.Headers.SetValue(HEADER_TENANT_ID, FAgentTenantId)

end;

procedure TMainData.DataConnectionResponse(Args: TXDataWebConnectionResponse);
begin
  if Args.Response.StatusCode = 401 then
  begin
{$IFDEF DEBUG}
    asm
      console.log('[Auth] DataConnectionResponse: 401 Unauthorized — attempting token refresh');
    end;
{$ENDIF}
    AuthService.LogTokenState('Before 401 refresh');
    RefreshSessionOrLogout(True);
  end;
end;

procedure TMainData.DeleteLocalValue(const Key: string);
begin
  if LocalValue[Key] <> '' then
    TLocalStorage.RemoveKey(Key);
end;

procedure TMainData.GetAppUser;
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
  try
    Await(DataConnection.OpenAsync);

    lRetval := Await(TXDataClientResponse, WebClient.RawInvokeAsync('IGiftAiderService.GetUserData', []));
    lResult := TJSObject(lRetval.Result);

    FAppUser := TGiftAidUser.Create;
    FAppUser.Assign(lResult);

    //Essentials linking
    EssentialsManager.WebClient := WebClient;

  except

  end;
end;

procedure TMainData.GetAgentAppUser;
var
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
begin
  Await(DataConnection.OpenAsync);

  lRetval := Await(TXDataClientResponse, WebClient.RawInvokeAsync('IGiftAiderService.GetAgentUserData', []));
  lResult := TJSObject(lRetval.Result);

  FAppUser := TGiftAidUser.Create;
  FAppUser.Assign(lResult);
end;

procedure TMainData.GetOrganisationName;
var
  lRetval: TXDataClientResponse;
  lOrgName: string;

begin
  Await(DataConnection.OpenAsync);
  lRetval := Await(TXDataClientResponse, WebClient.RawInvokeAsync('IOrganisationService.GetOrganisationName',
    [FTenantId]));
  lOrgName := JS.ToString(lRetval.ResultAsObject['value']);
  FOrganisationName := lOrgName;
  // FAppUser.OrganisationName := lOrgName;
end;

procedure TMainData.GetTenantData;
begin
  Await(GetOrganisationName);
  Await(GetOrganisationConfiguration);
end;

procedure TMainData.GetOrganisationConfiguration;
var
  lRetval: TXDataClientResponse;
  lConfigObj: JS.TJSObject;
  lOrgConfigJSON: string;

begin
  lRetval := Await(TXDataClientResponse, WebClient.RawInvokeAsync('IOrganisationService.GetOrganisationConfiguration',
    [FTenantId]));

  lOrgConfigJSON := JS.ToString(lRetval.ResultAsObject['value']);

  try
    if lOrgConfigJSON <> '' then
    begin
      lConfigObj := JS.toObject(TJSJSON.parse(lOrgConfigJSON));
      FOrganisationConfiguration := TOrganisationConfiguration.Create;
      FOrganisationConfiguration.Assign(lConfigObj);
    end
    else
    begin
      SetConfigurationToDefault;
    end;
  except
    SetConfigurationToDefault;
  end;
end;

function TMainData.GetOrganisationDisplayName: string;
begin
  Result := FOrganisationName;
  if UserIsAgent then
    Result := Result + ' (Agent: ' + FAgentName + ')';
  //    Result := Result + ' <span id="agent-name">(Agent: ' + FAgentName + ')</span>';
end;

procedure TMainData.SetOrganisationConfiguration;
begin
  Await(TXDataClientResponse, WebClient.RawInvokeAsync('IOrganisationService.SetOrganisationConfiguration',
    [FTenantId, FOrganisationConfiguration]));

end;

procedure TMainData.SetTenantId(const Value: string);
begin
  FTenantId := Value;
  GetTenantData;
end;

procedure TMainData.SetConfigurationToDefault;
begin
  FOrganisationConfiguration := TOrganisationConfiguration.Create;

  FOrganisationConfiguration.ClearDownSubmission := False;
  FOrganisationConfiguration.NoMatching := False;
  FOrganisationConfiguration.SaveHMRCPassword := False;
  FOrganisationConfiguration.DonorClaimStatusItemIndex := -1;
end;

function TMainData.GetConfig: TAppConfig;
begin
  Result := AppConfig;
end;

function TMainData.GetLocalValue(const Key: string): string;
begin
  Result := TLocalStorage.GetValue(Key);
end;

function TMainData.GetUserScope: TUserScope;
begin
  Result := TRttiEnumerationType.GetValue<TUserScope>(FAppUser.UserScope);
end;

procedure TMainData.InitModule;
var
  lCharityId, lEmail: string;

begin
  FErrorCount := 0;

  FormatSettings.DateSeparator := '/';
  FormatSettings.ShortDateFormat := 'dd/mm/yyyy';

  {$IFDEF DEBUG}
  Application.ErrorType := aeFooter; // aeSilent, aeDialog, aeAlert, aeFooter
  {$ELSE}
  Application.ErrorType := aeSilent; // aeSilent, aeDialog, aeAlert, aeFooter
  Application.OnError := self.OnApplicationError;
  {$ENDIF}
  if HasQueryParam('charityid', lCharityId) then
    LocalValue['charity-id'] := lCharityId;
  if HasQueryParam('usermail', lEmail) then
    LocalValue['user-email'] := lEmail;

  Await(LoadConfig);

  SharedData := TSharedData.Create(Application, WebClient);
  SharedData.DataConnection := DataConnection;

  SphinxLogin.ClientId := SphinxClientId;
  SphinxLogin.RedirectUri := SphinxRedirectUri;
  SphinxLogin.Scope := SphinxScopes;

  SphinxLogin.Login;

end;

procedure TMainData.InitUser;
begin
  DataConnection.Connected := True;
  Await(GetAppUser);
end;

procedure TMainData.InitAgentUser;
begin
  DataConnection.Connected := True;
  Await(GetAgentAppUser);
end;

procedure TMainData.LoadConfig;
var
  Conn: TXDataWebConnection;
  Response: IHttpResponse;
begin

  Conn := TXDataWebConnection.Create(nil);
  try

    Response := await(IHttpResponse, Conn.SendRequestAsync(THttpRequest.Create('config/config.json')));
    //    Response := TAwait.Exec<IHttpResponse>(Conn.SendRequestAsync(THttpRequest.Create('config/config.json')));
    if Response.StatusCode = 200 then
    begin
      Config.Load(Response.ContentAsText);
      DataConnection.URL := Config.BaseUrl;
      SphinxLogin.Authority := Config.AuthURL;
    end;

  finally
    Conn.Free;
  end;

end;

procedure TMainData.Logout(const ShowLogin: Boolean = True);
begin
  if FLogoutInProgress then
    Exit;

  FLogoutInProgress := True;
  MainTimer.Enabled := False;
{$IFDEF DEBUG}
  asm
    console.log('[Auth] Logout', ShowLogin);
  end;
  AuthService.LogTokenState('Logout');
{$ENDIF}

  // Only call the descendant method when the instance was actually swapped in WebDataModuleCreate.
  // Otherwise fall back to the standard end-session logout to avoid runtime "is not a function".
  if (SphinxLogin is TSphinxWebLoginCracker) and ShowLogin then
    TSphinxWebLoginCracker(SphinxLogin).LogoutAndEndSessionTo(SphinxRedirectUri)
  else
    SphinxLogin.LogoutAndEndSession;
end;

procedure TMainData.MainTimerTimer(Sender: TObject);
begin
  if SphinxLogin.IsLoggedIn then
    CheckAndRefreshSession;
end;

[Async]
procedure TMainData.CheckAndRefreshSession; async;
begin
  if not SphinxLogin.IsLoggedIn then
    Exit;

  if AuthService.IsTokenExpired or (AuthService.TimeToLiveInSeconds <= TOKEN_REFRESH_BUFFER_SECONDS) then
  begin
{$IFDEF DEBUG}
    asm
      console.log('[Auth] CheckAndRefreshSession: token expired or within refresh buffer');
    end;
    AuthService.LogTokenState('Timer refresh check');
{$ENDIF}
    RefreshSessionOrLogout(False);
  end;
end;

[Async]
procedure TMainData.RefreshSessionOrLogout(const AForceRefresh: Boolean); async;
var
  lResult: TAuthResult;
begin
  if FSessionRecoveryInProgress or FSessionLogoutTriggered then
  begin
{$IFDEF DEBUG}
    asm
      console.log('[Auth] RefreshSessionOrLogout skipped: recovery or logout already in progress');
    end;
{$ENDIF}
    Exit;
  end;

  if not AForceRefresh then
  begin
    if not SphinxLogin.IsLoggedIn then
      Exit;
    if not AuthService.IsTokenExpired and (AuthService.TimeToLiveInSeconds > TOKEN_REFRESH_BUFFER_SECONDS) then
      Exit;
  end;

{$IFDEF DEBUG}
  asm
    console.log('[Auth] RefreshSessionOrLogout: calling RefreshTokens', { force: AForceRefresh });
  end;
  AuthService.LogTokenState('Before RefreshTokens');
{$ENDIF}

  FSessionRecoveryInProgress := True;
  try
    lResult := await(TAuthResult, SphinxLogin.RefreshTokens(''));
    if lResult = nil then
    begin
{$IFDEF DEBUG}
      asm
        console.log('[Auth] RefreshTokens failed — session will be ended');
      end;
      AuthService.LogTokenState('RefreshTokens failed');
{$ENDIF}
      HandleSessionExpired;
    end
    else
    begin
{$IFDEF DEBUG}
      asm
        console.log('[Auth] RefreshTokens succeeded');
      end;
      AuthService.LogTokenState('RefreshTokens succeeded');
{$ENDIF}
      AuthService.InvalidateTokenCache;
      if Assigned(SharedData) then
        SharedData.RefreshJobs;
    end;
  finally
    FSessionRecoveryInProgress := False;
  end;
end;

procedure TMainData.HandleSessionExpired;
const
  SESSION_EXPIRED_MSG = 'Your session has expired. Please log in again.';
begin
  if FSessionLogoutTriggered then
    Exit;
{$IFDEF DEBUG}
  asm
    console.log('[Auth] HandleSessionExpired');
  end;
  AuthService.LogTokenState('HandleSessionExpired');
{$ENDIF}
  FSessionLogoutTriggered := True;
  MainTimer.Enabled := False;
  if Assigned(FShowMessageProc) then
    FShowMessageProc(SESSION_EXPIRED_MSG, TsmxDlgType.dltWarning)
  else
    window.alert(SESSION_EXPIRED_MSG);
  Logout;
end;

procedure TMainData.OnApplicationError(Sender: TObject; AError: TApplicationError; var Handled: Boolean);
begin
  if (AError.ALineNumber = FLastError.ALineNumber) and (SecondsBetween(Now, FLastErrorTime) < 60) then
  begin
    Inc(FErrorCount);
  end
  else
  begin
    FLastError.ALineNumber := AError.ALineNumber;
    FErrorCount := 1;
  end;

  SentryErrorProc(EApplicationException.Create(AError, FErrorCount), '', Handled);

end;

function TMainData.SentryAppId: string;
begin
  Result := Application.ExeName
end;

function TMainData.SentryDSN: string;
begin
  Result := WEB_SENTRY_DSN;
end;

procedure TMainData.ConfigureSentryEnvironment;
var
  LEnvironment: string;
  LDsn: string;
begin
  // bundle.min.js is already on the page; init needs a DSN or getClient() stays undefined.
  // Use bare Pascal vars in asm (not @Var — that is left as a literal and breaks the bundle).
  LDsn := WEB_SENTRY_DSN;
{$IFDEF DEBUG}
  LEnvironment := 'internal-crm';
{$ELSE}
  LEnvironment := 'production-crm';
{$ENDIF}
  asm
    if (typeof Sentry !== 'undefined') {
      Sentry.init({ dsn: LDsn, environment: LEnvironment });
    }
  end;
end;

procedure TMainData.SentryErrorProc(E: Exception; const AComment: string; var AHandled: Boolean;
  const CallUIHandler: Boolean);
begin

  // if Assigned(FErrorProc) then
  // FErrorProc('Error: ' + E.Message + '. NOT Logged at WebSentry');
  // Exit;

  if E.Message.Contains('FServerRecordCount') then
  begin
    // Swallow the excpetion - caused by a page being released before being fully loaded
    {$IFDEF DEBUG}
    if CallUIHandler and Assigned(FErrorProc) then
      FErrorProc('Error: ' + E.Message + '. Not logged and Not notified in Release Version');
    {$ENDIF}
    Exit;
  end;

  {$IFDEF NO_SENTRY}
  if Assigned(FErrorProc) then
    FErrorProc('Error: ' + E.Message + '. NOT Logged at WebSentry');
  {$ELSE}
  {$IFDEF RELEASE}
  if CallUIHandler and Assigned(FErrorProc) then
    FErrorProc('There has been an error and the developers have been notified');
  Exit;
  {$ENDIF}
  {$IFDEF DEBUG}
  if Assigned(FErrorProc) then
    FErrorProc('Error: ' + E.Message + '. Logged at WebSentry');
  {$ENDIF}
  {$ENDIF}
end;

procedure TMainData.SetLocalValue(const Key, Value: string);
begin
  TLocalStorage.SetValue(Key, Value);
end;

procedure TMainData.ShowMainPage;
begin
  TMainPage.DisplayPage(CONTENT_ELEMENT);
end;

function TMainData.SphinxClientId: string;
begin
  Result := Config.SphinxClientId;
  if Result = '' then
    Result := 'GAMTWeb';
end;

procedure TMainData.SphinxLoginUserLoggedIn(Args: TUserLoggedInArgs);
begin
{$IFDEF DEBUG}
  asm
    console.log('[Auth] SphinxLoginUserLoggedIn');
  end;
  AuthService.LogTokenState('SphinxLoginUserLoggedIn');
{$ENDIF}
  AfterLogInSuccess(Args);
end;

function TMainData.SphinxRedirectUri: string;
var
  I: Integer;
begin
  Result := Application.ExeName;
  I := Result.IndexOf('?');
  if I > 0 then
    Result := Result.Substring(0, I);
  I := Result.IndexOf('#');
  if I > 0 then
    Result := Result.Substring(0, I);
end;

function TMainData.SphinxScopes: string;
begin
  Result := 'openid email offline_access';
end;

// procedure TMainData.WebClientError(Error: TXDataClientError);
// begin
// if Assigned(FShowMessageProc) then
// FShowMessageProc(Error.ErrorMessage, TsmxDlgType.dltError);
// end;

procedure TMainData.WebDataModuleCreate(Sender: TObject);
var
  lOnUserLoggedIn: TUserLoggedInEvent;
begin
  ConfigureSentryEnvironment;
  // DFM creates a TSphinxWebLogin instance. We swap it for a descendant that can
  // call BuildLogoutUrl with a post-logout redirect URI (BuildLogoutUrl is strict protected).
  //
  // This avoids changing the DFM component type while still allowing the cleaner implementation.
  lOnUserLoggedIn := SphinxLogin.OnUserLoggedIn;
  FreeAndNil(SphinxLogin);
  SphinxLogin := TSphinxWebLoginCracker.Create(Self);
  SphinxLogin.OnUserLoggedIn := lOnUserLoggedIn;
  InitModule;
end;

procedure TMainData.SaveConfigData;
begin
  SetOrganisationConfiguration;
end;

procedure TMainData.ShowAgentMainPage;
begin
  Await(InitAgentUser);
  ShowMainPage;
end;

procedure TMainData.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebClient := TXDataWebClient.Create(Self);
  DataConnection := TXDataWebConnection.Create(Self);
  SphinxLogin := TSphinxWebLogin.Create(Self);
  MainTimer := TTimer.Create(Self);
  DummyDataset := TClientDataSet.Create(Self);
  DummySource := TDataSource.Create(Self);

  WebClient.BeforeLoadDFMValues;
  DataConnection.BeforeLoadDFMValues;
  SphinxLogin.BeforeLoadDFMValues;
  MainTimer.BeforeLoadDFMValues;
  DummyDataset.BeforeLoadDFMValues;
  DummySource.BeforeLoadDFMValues;
  try
    Name := 'MainData';
    SetEvent(Self, 'OnCreate', 'WebDataModuleCreate');
    SetEvent(Self, 'OnDestroy', 'WebDataModuleDestroy');
    Height := 270;
    Width := 416;
    WebClient.SetParentComponent(Self);
    WebClient.Name := 'WebClient';
    WebClient.Connection := DataConnection;
    WebClient.Left := 40;
    WebClient.Top := 88;
    DataConnection.SetParentComponent(Self);
    DataConnection.Name := 'DataConnection';
    DataConnection.URL := 'http://localhost:2018/GAOnline';
    SetEvent(DataConnection, Self, 'OnRequest', 'DataConnectionRequest');
    SetEvent(DataConnection, Self, 'OnResponse', 'DataConnectionResponse');
    DataConnection.Left := 40;
    DataConnection.Top := 24;
    SphinxLogin.SetParentComponent(Self);
    SphinxLogin.Name := 'SphinxLogin';
    SetEvent(SphinxLogin, Self, 'OnUserLoggedIn', 'SphinxLoginUserLoggedIn');
    SphinxLogin.Left := 336;
    SphinxLogin.Top := 24;
    MainTimer.SetParentComponent(Self);
    MainTimer.Name := 'MainTimer';
    MainTimer.Enabled := False;
    MainTimer.Interval := 30000;
    SetEvent(MainTimer, Self, 'OnTimer', 'MainTimerTimer');
    MainTimer.Left := 336;
    MainTimer.Top := 192;
    DummyDataset.SetParentComponent(Self);
    DummyDataset.Name := 'DummyDataset';
    DummyDataset.Left := 123;
    DummyDataset.Top := 171;
    DummySource.SetParentComponent(Self);
    DummySource.Name := 'DummySource';
    DummySource.DataSet := DummyDataset;
    DummySource.Left := 216;
    DummySource.Top := 176;
  finally
    WebClient.AfterLoadDFMValues;
    DataConnection.AfterLoadDFMValues;
    SphinxLogin.AfterLoadDFMValues;
    MainTimer.AfterLoadDFMValues;
    DummyDataset.AfterLoadDFMValues;
    DummySource.AfterLoadDFMValues;
  end;
end;

end.

